import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';


export const MyHorizontalBarPlot = ({data, max_xaxis, title, fuelTypes, fuelTypeInfo}) =>{

    return (
        <BarChart
          width={400}
          height={600}
          data={data}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
          layout="vertical"
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" domain={[0, parseInt(max_xaxis/100)*100 +100]} />
          <YAxis type="category"  dataKey="name" tick={{ fontSize: 14 }} />

          <Tooltip />
          <Legend />
          {fuelTypes.map(pf => <Bar key={`ports_bar_${pf.name}`} dataKey={pf.name}  name={fuelTypeInfo[pf.name].short_display_name} stackId="a" fill={fuelTypeInfo[pf.name].color_name} /> )}
        </BarChart>
    );
  }


